var _excluded = ["name", "type", "fieldProps", "additionalClassName", "errorAdditionalClassName", "isWrapFormGroup", "onChange", "sizeLg", "value"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import { Input as InputSimple } from 'components/form/fields/simple/Input';
import { Field } from '@collaborator/npm_modules/dist/components/form/field';
var Input = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var name = _ref.name,
      type = _ref.type,
      fieldProps = _ref.fieldProps,
      additionalClassName = _ref.additionalClassName,
      errorAdditionalClassName = _ref.errorAdditionalClassName,
      isWrapFormGroup = _ref.isWrapFormGroup,
      onChange = _ref.onChange,
      sizeLg = _ref.sizeLg,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Field, _extends({
    name: name,
    type: type,
    value: value
  }, fieldProps, {
    render: function render(_ref2) {
      var input = _ref2.input,
          meta = _ref2.meta;

      var handlerChange = function handlerChange(e) {
        input.onChange(e);

        if (onChange) {
          onChange(e);
        }
      };

      return (
        /*#__PURE__*/
        // @ts-ignore
        React.createElement(InputSimple, _extends({
          ref: ref,
          error: meta.submitError || meta.error,
          additionalClassName: additionalClassName,
          errorAdditionalClassName: errorAdditionalClassName,
          isWrapFormGroup: isWrapFormGroup,
          sizeLg: sizeLg,
          value: value
        }, input, props, {
          onChange: handlerChange
        }))
      );
    }
  }));
});
export { Input };